export default function JsonCompare(compare1, compare2) {
    return JSON.stringify(compare1) !== JSON.stringify(compare2)
}
